/**
 * FERP Portal - Event List Page (DRR-074: Tabulator DRY Template)
 *
 * MONITOR Phase: System-wide occurrences including saga triggers and workflow transitions.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function EventListPage() {
  return <TabulatorPrimitiveManager primitiveType="event" />;
}

export default EventListPage;
